/* eslint-disable react/no-danger */
import React, { useCallback } from 'react'
import PropTypes from 'prop-types'

import { withTranslation } from '../../../i18n'

import * as Styled from './styles'
import { HostItem } from '../styles'
import { Members } from '../../../public/static/svgs/Members'

const MembersBlock = ({ t, episode, isShown, toggleBlock }) => {
  const onBlockToggle = useCallback(() => toggleBlock(episode.id), [isShown])

  return (
    <>
      <Styled.MembersLink onClick={onBlockToggle} isOpen={isShown}>{t('members')} <Members/></Styled.MembersLink>
      <Styled.MembersPopover isShown={isShown}>
        {!!episode.experts.length && <div className="col">
          <div className="title">{t('experts')}:</div>
          {episode.experts.map(person =>
            <HostItem key={person.id}>
              <img src={person.photo || '/static/images/empty-artist.svg'} alt={person.name}/>
              <div className="info">
                <div className="name">{person.name}</div>
                <div className="text">{person.description}</div>
              </div>
            </HostItem>
          )}
        </div>}
        {!!episode.musicians.length && <div className="col">
          <div className="title">{t('artists')}:</div>
          {episode.musicians.map(person =>
            <HostItem key={person.id}>
              <img src={person.photo || '/static/images/empty-artist.svg'} alt={person.name}/>
              <div className="info">
                <div className="name">{person.name}</div>
                <div className="text">{person.genre}</div>
              </div>
            </HostItem>
          )}
        </div>}
        <Styled.PopoverCloseBtn onClick={onBlockToggle}/>
      </Styled.MembersPopover>
    </>
  )
}

MembersBlock.propTypes = {
  t: PropTypes.func.isRequired,
  toggleBlock: PropTypes.func.isRequired,
  isShown: PropTypes.bool.isRequired,
  episode: PropTypes.instanceOf(Object).isRequired
}

export default withTranslation(['podcasts'])(MembersBlock)
